module.exports = __webpack_public_path__ + "static/img/joinus_bg.625b2dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/joinus_bg.jpg
// module id = SlS7
// module chunks = 1